module.exports = __webpack_public_path__ + "img/cases-brand-tommee-11.b178de3f.jpg";